import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
  name: "excludeFilter",
  pure: false
})
export class ExcludePipe implements PipeTransform {
  transform(items: any[], filter: string[]): any {
    if (!items || !filter) {
      return items;
    }
    return items.filter(item => filter.indexOf(item["Code"]) === -1);
  }
}
